/**
 * Namecheap
 *
 * Generates affiliate links for Namecheap.
 */

const AFFILIATE_ID = '122142'


export function affiliateLink(domain: string): string {
  return `https://www.namecheap.com/domains/registration/results.aspx?domain=${domain}.com&affId=${AFFILIATE_ID}`
}


// WEBPACK FOOTER //
// ./src/service/namecheap.ts